<template>
  <el-upload
    class="avatar-uploader"
    ref="upload"
    :action="action"
    :show-file-list="false"
    :on-success="handleSuccess"
    :on-error="handleError"
    :on-change="handleChange"
    :before-upload="beforeUpload"
    :on-remove="handleRemove"
    :showFileList="false"
    :auto-upload="autoUpload"
    v-bind="$attrs"
    :limit="limit"
    :file-list="fileList"
    :on-exceed="handleExceed"
  >
    <div v-if="imageUrl" style="height: 0; width: 0" slot="trigger"></div>
    <div
      v-if="imageUrl"
      class="imgUrl"
      @mouseenter="isMouseIn = true"
      @mouseleave="isMouseIn = false"
      @focus="isMouseIn = true"
      @blur="isMouseIn = false"
      :style="
        showOperateGroup
          ? {
              width: widthSize + 'px',
              height: heightSize + 'px',
              'line-height': heightSize + 'px',
            }
          : {}
      "
    >
      <div
        v-if="showOperateGroup && isMouseIn"
        @click.stop="showViewer = true"
        class="operationGroup"
        :style="{
          width: widthSize + 'px',
          fontSize: '26px',
          height: heightSize + 'px',
          'line-height': heightSize + 'px',
        }"
      >
        <el-icon @click.stop="showViewer = true" style="margin-right: 10px"><ZoomIn color="#fff" /></el-icon>
        <el-icon @click.stop="handleDelete"><Delete color="#fff" /></el-icon>
        <!-- <el-button icon="el-icon-download" type="text" @click.stop="hanldeDownload"></el-button> -->
      </div>
      <img
        :src="imageUrl"
        class="avatar"
        alt=""
        @click.stop="() => {}"
        :style="{ width: widthSize + 'px', height: heightSize + 'px' }"
        :preview-src-list="[imageUrl]"
      />
    </div>
    <i
      v-else
      v-loading="loading"
      class="el-icon-plus avatar-uploader-icon"
      :style="{
        width: widthSize + 'px',
        height: heightSize + 'px',
        lineHeight: heightSize + 'px',
      }"
      slot="trigger"
    >
      <span class="plus">+</span>
    </i>
    <div
      style="color: #409eff; cursor: default"
      @click.stop="
        e => {
          e.stopPropagation();
        }
      "
    >
      <slot name="tip"></slot>
    </div>
    <div
      @click.stop="
        e => {
          e.stopPropagation();
        }
      "
    >
      <ElImageViewer v-if="showViewer && imageUrl" :url-list="[imageUrl]" @close="closeViewer"></ElImageViewer>
    </div>
  </el-upload>
</template>
<script>
import { ElImageViewer } from 'element-plus';
import { Delete, ZoomIn } from '@element-plus/icons-vue';
import { message, notify } from '@/utils/tools';

export default {
  name: 'FileUpload',
  components: {
    ElImageViewer,
    ZoomIn,
    Delete,
  },
  props: {
    value: [String, File],
    imgSrc: [String, File],
    limit: {
      type: Number,
      default: 1,
    },
    heightSize: {
      type: Number,
      default: 120,
    },
    widthSize: {
      type: Number,
      default: 120,
    },
    maxSize: {
      type: Number,
      default: 5 * 1024 * 1024,
    },
    showOperateGroup: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: '#',
    },
  },
  computed: {
    autoUpload() {
      return this.action !== '#';
    },
  },
  watch: {
    value: {
      handler(val) {
        if (!val) {
          this.fileList = [];
          this.imageUrl = '';
        }
      },
    },
    imgSrc: {
      handler(val) {
        this.processImgSrc(val);
      },
    },
  },
  data() {
    return {
      imageUrl: '',
      loading: false,
      fileList: [],
      showViewer: false,
      isMouseIn: false,
    };
  },
  methods: {
    processImgSrc(val) {
      if (val) {
        if (val instanceof File) {
          this.imageUrl = URL.createObjectURL(val);
        } else {
          this.imageUrl = val;
        }
      } else {
        this.imageUrl = '';
        this.fileList = [];
      }
    },
    hanldeDownload() {
      if (this.imageUrl.indexOf('blob:') !== -1) {
        // 证明是前端自己生成的地址
        window.open(this.imageUrl, '_blank');
      } else {
        window.open(this.imageUrl + '&inline=true', '_blank');
      }
    },
    handleSuccess(res, file, fileList) {
      this.loading = false;
      if (Object.prototype.toString.call(res) === '[object Object]' && !res.success) {
        notify(res.message || '上传失败', 'warning');
        this.fileList = [];
        return;
      }
      this.$emit('update:modelValue', res.data.url);
      this.$nextTick(() => {
        this.imageUrl = URL.createObjectURL(file.raw);
      });

      this.fileList = fileList.map(a => {
        return {
          ...a,
          uuid: res?.data || 'id' + getUuid(),
        };
      });
    },
    handleChange(file) {
      if (this.autoUpload) return;
      if (file.raw) {
        this.processImgSrc(file.raw);
        this.$emit('update:modelValue', file.raw);
      }
    },
    handleDelete(e) {
      e.stopPropagation();
      this.fileList = [];
      this.imageUrl = '';
      this.$refs.upload.clearFiles();
      this.$emit('update:modelValue', '');
      this.$emit('delete');
    },
    clearFiles() {
      this.$refs.upload.clearFiles();
    },
    handleError(e, file) {
      notify(`${file.name}上传失败`, 'warning');
      this.loading = false;
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter(a => a.uuid !== file.uuid);
    },
    beforeUpload(file) {
      if (this.fileList.find(a => a.name === file.name)) {
        // 校验不通过会调用handleRemove,因此此处需要uploadCount++
        message(`已存在相同文件名附件:${file.name}`, 'warning');
        return false;
      }
      const size = file.size;
      if (size > this.maxSize) {
        // 校验不通过会调用handleRemove,因此此处需要uploadCount++
        message(`${file.name}大小超过${handleFileSize(this.maxSize)}，请重新选择文件`, 'warning');
        this.fileList = [];
        this.$refs.upload.clearFiles();
        return false;
      }
      this.imageUrl = '';
      this.loading = true;
    },
    handleExceed() {
      message(`最多支持${this.limit}个附件`, 'warning');
    },
    closeViewer() {
      this.showViewer = false;
    },
  },
  created() {
    this.processImgSrc(this.imgSrc);
  },
};
</script>
<style scoped lang="scss">
.avatar-uploader {
  display: flex;
  align-items: flex-start;
}
.avatar-uploader ::v-deep .el-upload {
  text-align: left;
  flex-direction: column;
  align-items: flex-start;
}
::v-deep .el-loading-spinner {
  transform: translate(0, -50%);
  margin-top: 0;
  z-index: 9999;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  text-align: center;
  span {
    font-style: normal;
    font-weight: normal;
  }
}
.imgUrl {
  display: flex;
  align-items: flex-start;
  position: relative;
}
.avatar {
  border-radius: 5px;
  display: block;
}
.operationGroup {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    margin: 0px;
    font-size: 20px;
    height: 30px;
    width: 30px;
    color: #fff;
    i {
      position: relative;
      top: -5px;
    }
  }
}
</style>
